import React from 'react';
import { useFocusEffect } from '@react-navigation/native';

import { useLastInteractedStore } from '../../../../context/LastInteractedStore';
import { useReorderOrdersV2 } from '../../../ReorderScreen/hooks';
import { OrdersListWrapper } from '../../components';

export const DigitalOrders = () => {
  const lastInteractedStore = useLastInteractedStore();

  const currentRestaurantId = lastInteractedStore?.restaurantId
    ? Number.parseInt(lastInteractedStore.restaurantId, 10)
    : undefined;

  const {
    orders,
    fetchInitialOrders,
    isFetchingInitialOrders,
    isFetchingMoreOrders,
    canFetchMoreOrders,
    mostRecentOrder,
    fetchMoreOrders,
  } = useReorderOrdersV2(currentRestaurantId);

  // Fetch orders on screen focus.
  useFocusEffect(fetchInitialOrders);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <OrdersListWrapper
      canReorder
      orders={orders}
      fetchMoreOrders={fetchMoreOrders}
      isFetchingInitialOrders={isFetchingInitialOrders}
      isFetchingMoreOrders={isFetchingMoreOrders}
      canFetchMoreOrders={canFetchMoreOrders}
      mostRecentOrder={mostRecentOrder}
    />
  );
};
